import SelectSearch from 'react-select';
import React from "react";
import { useLocation } from 'react-router-dom';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const location = useLocation();
    console.log(location?.pathname === '/jobsummary');
    const dropdownOptionsIssueListPages = ['/jobsummary','/locations','/addlocations','/addcompany']
    const options = props.isObject ? props.options?.map((option) => {
        return {
            label: option.name,
            value: option.id
        }
    }) : props.options?.map((option) => ({
        label: option,
        value: option
    }))
    const updateValue = (target) => {
        if(target === null){
            props.updateValue({
                value:undefined,
                action: 'remove',
                name: props.name
            });
            return;
        }
        props.updateValue({
            value: {
                id: target.value,
                name: target.label
            },
            action: 'add',
            name: props.name
        });
    }
    const readValue = (props) => {
        if (props.value && props.value.length) {
            return {
                label: props.value[0]?.name,
                value: props.value[0]?.id
            }
        }
        return null;
    }

    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor:  isSelected ? "#004D40" : null,
                color:  isSelected ? "#fff" : null,
                 ':active':{
                    background:"#004D40"
                },
                ':hover':{
                    background:"#004D40",
                    color:"#fff"
                }
            };
        }
    };
    const onMenuOpen = () => {
        setTimeout(()=>{
          const selectedEl = document.getElementsByClassName("MyDropdown__option--is-selected")[0];
          if(selectedEl){
            selectedEl.scrollIntoView({behavior:'smooth', inline: 'end'});
          }
        },15);
      };

      
    return (
        <div className={`${props.divClass || 'col-lg-6 col-md-12'}`}>
            <div className="form-group">
                <label htmlFor={props.name}>{props.label} <span className='required'>{props?.star}</span></label>
                <SelectSearch autoComplete={"off"}
                    isDisabled = {props?.isDisabled ? true : false}
                    onMenuOpen = {onMenuOpen}
                    menuPlacement='bottom'
                    menuPosition={dropdownOptionsIssueListPages?.indexOf(location?.pathname) < 0 ? `fixed` : ''}
                    classNamePrefix={`MyDropdown`}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: '#004D40',
                            primary: '#004D40',
                        }
                    })}
                    styles={colourStyles}
                    options={options}
                    defaultValue={readValue(props)}
                    value={readValue(props)}
                    placeholder={props.placeholder || "Select"}
                    search={props.search}
                    onChange={(event) => updateValue(event)} 
                    isClearable={props?.isClearable ? true : false}
                    />
                {props.errors && props.errors.map(error => (<div className="invalid-input">{error}</div>))}
            </div>
        </div>
    )
}
